import { render, staticRenderFns } from "./InboxViewMessage.vue?vue&type=template&id=1707d051&scoped=true&"
import script from "./InboxViewMessage.vue?vue&type=script&lang=ts&"
export * from "./InboxViewMessage.vue?vue&type=script&lang=ts&"
import style0 from "./InboxViewMessage.vue?vue&type=style&index=0&id=1707d051&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707d051",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCardText,VCardTitle,VCol,VIcon,VRow})
